// extracted by mini-css-extract-plugin
export default {"mt20":"style_mt20_CUCYh"};